import { WifiOff, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ConnectionErrorScreenProps {
  onRetry: () => void;
  isRetrying?: boolean;
}

export function ConnectionErrorScreen({ onRetry, isRetrying }: ConnectionErrorScreenProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-6 text-center">
      <div className="w-14 h-14 rounded-full bg-muted flex items-center justify-center mb-6">
        <WifiOff className="h-7 w-7 text-muted-foreground" />
      </div>
      <h1 className="text-xl font-semibold text-foreground mb-2">
        Unable to connect to Luma servers
      </h1>
      <p className="text-muted-foreground text-sm max-w-sm mb-8">
        Check your internet connection and try again.
      </p>
      <Button onClick={onRetry} size="lg" disabled={isRetrying}>
        {isRetrying ? (
          <>
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
            Retrying…
          </>
        ) : (
          'Retry'
        )}
      </Button>
    </div>
  );
}
